var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchoolStudent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.815,
    height: 12,
    viewBox: "0 0 11.815 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "School_Student_",
    "data-name": "School Student ",
    d: "M3.8,12a1.748,1.748,0,0,1-1.741-1.754V8.155l-.312-.1A1.436,1.436,0,0,1,.836,6.247l.587-1.819a1.424,1.424,0,0,1,.648-.8A1.747,1.747,0,0,1,3.8,2.06h5.8a1.747,1.747,0,0,1,1.734,1.605,1.424,1.424,0,0,1,.585.763l.586,1.819A1.434,1.434,0,0,1,11.6,8.053l-.251.082v2.111A1.748,1.748,0,0,1,9.605,12ZM1.738,6.542a.479.479,0,0,0,.3.6l.055.018a1.756,1.756,0,0,1,.808-1.147l.028-.087L3.1,5.419a1.753,1.753,0,0,1-.777-.682Zm9.568.6a.48.48,0,0,0,.3-.6L11.046,4.8a1.75,1.75,0,0,1-.79.643l.171.531A1.756,1.756,0,0,1,11.306,7.144Zm-8.4-1.13a1.722,1.722,0,0,1,.9-.25h5.8a1.722,1.722,0,0,1,.822.208l-.014-.045-.157-.486a1.724,1.724,0,0,1-.651.127H3.8a1.723,1.723,0,0,1-.7-.149Zm6.139-4.1h0Zm-.948,0V1.434A.477.477,0,0,0,7.622.955h-1.9a.477.477,0,0,0-.474.478v.478H4.3V1.434A1.428,1.428,0,0,1,5.725,0h1.9A1.428,1.428,0,0,1,9.045,1.434v.478Zm-2.846,0h0Zm-.949,0Z",
    transform: "translate(-0.766)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchoolStudent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/school-student.62bb291cf5244db13d046489a239657f.svg";